import { createSlice } from '@reduxjs/toolkit'

// general imports
import {
  ApiRequestDataType,
  ApiRequestStatus,
  StoredErrorResponseType,
} from '../../../types/api/api.types'
import { confirmUpdateUserEmailThunk } from '../thunks/user-profile.thunk'

export type confirmUpdateUserEmailState = {
  // eslint-disable-next-line
  requestResponse: ApiRequestDataType<any>
}

export const initialState: confirmUpdateUserEmailState = {
  requestResponse: {
    status: ApiRequestStatus.IDLE,
    data: null,
  },
}

const confirmUpdateUserEmailSlice = createSlice({
  name: 'confirmUpdateUserEmailSlice',
  initialState: initialState,
  reducers: {
    resetconfirmUpdateUserEmailState: (state) => {
      ;(state.requestResponse.status = ApiRequestStatus.IDLE), (state.requestResponse.data = null)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(confirmUpdateUserEmailThunk.pending, (state) => {
        state.requestResponse.status = ApiRequestStatus.PENDING
        state.requestResponse.data = null
        state.requestResponse.error = {} as StoredErrorResponseType
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .addCase(confirmUpdateUserEmailThunk.fulfilled, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.FULFILLED

        // state.requestResponse.data = action.payload.description
      })
      .addCase(confirmUpdateUserEmailThunk.rejected, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.REJECTED
        state.requestResponse.error = action.payload as StoredErrorResponseType
      })
  },
})

export const { resetconfirmUpdateUserEmailState } = confirmUpdateUserEmailSlice.actions
export default confirmUpdateUserEmailSlice.reducer
